<template>
  <div class="top-bar">
    <div class="logo" @click="home">Photographers101</div>
    <!--<social-share class="social-share"></social-share>-->
    <login-status class="login-status"></login-status>
  </div>
</template>

<script>
import * as types from '@/store/mutation-types'
import LoginStatus from '../common/LoginStatus.vue'

export default {
  name: 'top-bar',
  components: {
    LoginStatus
  },
  methods: {
    home() {
      this.$router.push('/main')
      window.location.reload()
    },
    signup() {
      this.$store.dispatch(types.SET_MODAL_COMPONENT, {
        component: 'signup',
        active: true,
        type: 'full'
      })
    },
    request() {
      this.$store.dispatch(types.SET_MODAL_COMPONENT, {
        component: 'requestPage',
        active: true,
        type: 'box'
      })
    },
    alert() {
      // console.log('click ', 1)
      this.$store.dispatch(types.SET_MODAL_ALERT, {
        active: true,
        text: '테스트 해봐요'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.top-bar {
  display: block;
  min-height: 50px;
  .logo {
    top: 12px;
    position: absolute;
    display: block;
    width: 266px;
    height: 27px;
    cursor: pointer;
    font-family: Poppins;
    font-size: 36px;
    font-weight: 800;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #000000;
  }
  .login-status {
    position: absolute;
    top: 13px;
    right: -6px;
  }
  .social-share {
    margin: auto;
    position: absolute;
    right: 20%;
    display: inline-block;
  }
}
</style>
